// src/hooks/useSaveRole.ts
import { useMutation } from "@tanstack/react-query";
import api from "../api";

export const useSaveRole = () =>
  useMutation({
    mutationFn: (payload: any) => api.post("/roles/v1", payload),
  });
